<template>
    <label
        class="p-6 flex flex-col justify-center items-center border border-dashed border-purple rounded-1.25 cursor-pointer"
        :for="uniqueId"
        @dragenter="drop = true"
        @dragover="drop = true"
        @dragleave="drop = false"
        @drop="uploadFile($event, true)"
    >

        <div class="mb-1.25 text-xs font-medium text-gray-370 dark:text-white">
            Select File or Drag & Drop
        </div>

        <div class="text-xs text-gray-280">
            {{ fileSizeText }}
        </div>

        <input
            class="hidden"
            :id="uniqueId"
            type="file"
            accept="image/*, application/pdf"
            multiple
            @change="uploadFile($event, false)"
        />
    </label>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    fileSizeText: {
        type: String,
        default: 'Maximum file size 8MB',
    },
    title: {
        type: String,
        default: 'Select File or Drag & Drop',
    },
})

const uploadedFiles = defineModel('uploadedFiles', { type: Array, default: () => [] })

const drop = ref(false)

const uniqueId = `fileId-${Math.random().toString(36).slice(2, 10)}`

function uploadFile(event, isDrop) {
    drop.value = isDrop

    const { dataTransfer = {}, target = {} } = event
    const filesList = isDrop ? dataTransfer.files : target.files
    const fileListAsArray = Array.from(filesList)

    uploadedFiles.value = [...uploadedFiles.value, ...fileListAsArray]

    event.target.value = null
}
</script>
